<template>
    <PublicProfileLayout role="student">
            <div class="max-w-md w-full text-center" style="margin-top: 20%;">
                <h2 class="text-3xl font-extrabold text-gray-900 mb-4">Request sent successfully!</h2>
                <p class="text-gray-600 mb-6">Your request is successfully sent to the {{ tutorName }} tutor.</p>
                <Button label="Home" class="orange-button" @click="toHome" />
            </div>
    </PublicProfileLayout>
</template>

<script setup>
import PublicProfileLayout from '@/layout/PublicProfileLayout.vue';
import router from '@/router';
import { Button } from 'primevue';

const toHome = () => {
    const redirectPath = '/student_dashboard';
    router.push(redirectPath);
};
</script>
